import { StyleSheet } from "react-native";
import { COLORS } from "src/theme/constants";
import { theme } from "src/theme/theme";

export const styles = StyleSheet.create({
  container: {
    flexGrow:1,
    backgroundImage: theme.colors.accountDeletionGradient,
  },
  headerContainer: {
    flexDirection:"row",
    justifyContent:"center",
    gap:theme.spacing.xxss,
    height:100
  },
  col: {
    flexDirection:"column",
    gap:theme.spacing.md
  },
  platformIconImage:{
    width:18,
    height:18,
    resizeMode:"contain"
  },
  mobileBtn: {
    backgroundColor:theme.colors.black
  },
  hyperlink: {
    fontSize:theme.fontsize.cs,
    fontFamily:theme.fontFamily.robotoRegular,
    fontWeight:theme.fontweight.light,
    color:COLORS.skyBlue,
    textDecorationLine: "underline",
  },
  bottomButtonsContainer: {
    flexDirection:"row",
    alignItems:"center",
    // justifyContent:"space-between",
    marginTop:theme.margin.lg,
    gap:theme.spacing.reg,
    flex:1,
  },
  platformBtn: {
    backgroundColor:theme.colors.accountDeletionWebButton,
    borderRadius:theme.radius.xxs,
    padding:theme.spacing.sm,
    paddingHorizontal:theme.spacing.md,
    width:130,
    flexDirection:"row",
    alignItems:"center",
    justifyContent:"space-between",
  },
  platformBtnTxt: {
    fontSize:theme.fontsize.cs,
    fontWeight:theme.fontweight.regular,
    color: theme.colors.white,
  },
  deleteCardContainer: {
    borderRadius:theme.radius.ssm,
    backgroundColor:theme.colors.white,
    borderWidth:1,
    borderColor: "#E4ECDF",
    padding:theme.spacing.md,
    paddingHorizontal:theme.spacing.xlg,
    marginHorizontal:theme.margin.xxl,
    flex:1,
    elevation:10
  },
  deleteCardContainerNoFlex: {
    borderRadius:theme.radius.ssm,
    backgroundColor:theme.colors.white,
    borderWidth:1,
    borderColor: "#E4ECDF",
    padding:theme.spacing.md,
    paddingHorizontal:theme.spacing.xlg,
    marginHorizontal:theme.margin.xxl,
    elevation:10,
  },
  footerContainer: {
    marginBottom:theme.margin.xxl2,
  },
  footerTxt: {
    fontSize:theme.fontsize.reg,
    fontFamily:theme.fontFamily.robotoRegular,
    fontWeight:theme.fontweight.light,
    color:COLORS.charcoalGray,
    lineHeight:25,
    textAlign:"center",
  },
  footerHeaderTxt: {
    fontSize:theme.fontsize.reg,
    fontFamily:theme.fontFamily.robotoMedium,
    fontWeight:theme.fontweight.bold,
    color:COLORS.charcoalGray,
    lineHeight:25,
    textAlign:"center",
  },
  loginViaTxt: {
    fontSize:theme.fontsize.reg,
    fontFamily:theme.fontFamily.robotoRegular,
    color:COLORS.charcoalGray,
  },
  separator: {
    width:"100%",
    height:1,
    backgroundColor:COLORS.lightGray,
    marginVertical:theme.margin.md
  },
  alertIcon: {
    width:36,
    height:36,
    resizeMode:"contain",
    // backgroundColor:"yellow"
  },
  rowCenter: {
    flexDirection:"row",
    justifyContent:"center",
    alignItems:"stretch"
  },
  brandLogo: {
    marginHorizontal:"auto",
    width:130,
    height:42,
    transform:"scale(1.25)",
    resizeMode:"contain",
    marginVertical:theme.margin.xl
  },
  headerTxt: {
    fontFamily:theme.fontFamily.robotoBold,
    fontWeight:theme.fontweight.bold,
    fontSize:theme.fontsize.lg,
    color:theme.colors.white,
  },
  contentContainer: {
    width: "100%",
    backgroundColor:theme.colors.white,
    marginTop:"auto",
    padding: theme.spacing.lg,
    borderTopLeftRadius:theme.radius.ssm,
    borderTopRightRadius:theme.radius.ssm,
  },
  cardTitleTxt: {
    fontFamily:theme.fontFamily.robotoBold,
    fontWeight:theme.fontweight.semiBold,
    color:COLORS.charcoalGray,
    fontSize:theme.fontsize.mmd,
    marginBottom:theme.margin.xlg,
    textAlign:"center",
  },
  deleteStepsTxt: {
    fontSize:theme.fontsize.cs,
    fontFamily:theme.fontFamily.robotoRegular,
    fontWeight:theme.fontweight.light,
    color:COLORS.darkGray,
  },
  mailBtnContainer: {
    borderRadius: theme.radius.xxl,
    alignSelf: "flex-start",
    backgroundColor: "rgba(255, 255, 255, 0.12)",
    padding: theme.spacing.reg,
    paddingVertical: theme.spacing.xs,
    borderRadius: theme.radius.xxl,
    borderWidth: 1,
    borderColor: "rgba(255, 255, 255, 0.12)",
    marginVertical: theme.margin.md,
  },
  mailBtnTxt: {
    color: theme.colors.white,
  },
  accountDeletionSubscript: {
    textTransform: "uppercase",
    fontSize: theme.fontsize.sm,
    fontWeight: theme.fontweight.bold,
    letterSpacing: theme.spacing.xxs,
    color: "rgba(255, 255, 255, 0.72)",
  },
  accountDeletionHeader: {
    fontSize: theme.fontsize.xxl,
    color: theme.colors.white,
    marginBottom: theme.margin.md,
    fontWeight:theme.fontweight.bold
  },
  deleteGuidelines: {
    color:COLORS.darkGray,
    fontSize:theme.fontsize.cs,
    fontWeight:theme.fontweight.light,
    fontFamily:theme.fontFamily.robotoRegular,
    lineHeight:29
  },
  highlightedText: {
    fontSize:theme.fontsize.cs,
    fontWeight:theme.fontweight.regular,
  },
  deleteByMailBtn: {
    backgroundColor:"#0b3e8b",
    padding:theme.spacing.reg,
    paddingHorizontal:theme.spacing.mmd,
    borderRadius:theme.radius.reg,
    alignSelf:"flex-start",
    marginBottom:theme.margin.md
  },
  deleteByMailTxt: {
    fontWeight:theme.fontweight.bold,
    color: theme.colors.white,
  },
});
